import Message from './main'
import messageController from './MessageController'
import MessageBox from './MessageBox'

let installed = false

const MessagePlugin = {
  install (Vue) {
    if (installed) {
      return
    }

    /**
     * 创建 message list 容器
     */
    let $messageList = document.querySelector('#gkui-message-list')

    if (!$messageList) {
      $messageList = document.createElement('div')

      $messageList.id = 'gkui-message-list'

      document.body.appendChild($messageList)
    }
    installed = true

    Vue.prototype.$Message = Message

    new Vue({
      render: h => h(MessageBox)
    }).$mount('#gkui-message-list')
  }
}

export default MessagePlugin

export {
  messageController
}
